// MQTT 只传状态码；旧固件仍发送中文时保留原值。
const labels = {
  HS_UNINIT: '未初始化',
  HS_DOWN: '放钩',
  HS_DOWNSLOW: '慢速放钩',
  HS_WAITUNHOOK: '等待脱钩',
  HS_UP: '回收',
  HS_INSTORE: '入仓中',
  HS_LOCKED: '已锁定',
  HS_STOP: '停止',
  HS_TOPFAULT: '异常到顶'
}

export function getHookStatusLabel (value) {
  const raw = String(value || '').trim()
  return labels[raw.toUpperCase()] || raw || '状态未知'
}

export function isHookTopFault (value) {
  const raw = String(value || '').trim()
  return raw.toUpperCase() === 'HS_TOPFAULT' || raw === '异常到顶'
}
